<template>
	<focus-lock :return-focus="true">
		<div class="popup popup--confirmation">
			<div class="popup__content">
				<div class="popup__header">
					<h3 class="popup__heading">{{ heading }}</h3>
				</div>

				<div class="popup__body">
					<slot></slot>
				</div>
			</div>

			<div class="popup-footer popup-footer--inline">
				<button
					type="button"
					class="popup-footer__button btn--secondary"
					@click="closeMethod"
				>
					{{ closeText }}
				</button>
				<button
					type="button"
					@click="confirm"
					class="popup-footer__button"
				>
					{{ confirmText }}
				</button>
			</div>
		</div>
		<div class="overlay"></div>
	</focus-lock>
</template>

<script>
// Styles
import '@/sass/components/_popup.scss';

// Components
import FocusLock from 'vue-focus-lock';

export default {
	props: ['confirmText', 'confirmMethod', 'closeText', 'closeMethod', 'confirmMethodParams', 'heading'],
	components: {
		FocusLock
	},
	methods: {
		confirm() {
			this.confirmMethod(this.confirmMethodParams);
			this.closeMethod();
		}
	},
	mounted() {
		scroll(0, 0);

		const modals = document.getElementsByClassName('modal');

		for (let modal of modals) {
			modal.scrollTop = 0;
		}

		document.getElementsByClassName('search-popout')[0].scrollTop = 0;
	}
};
</script>
